// Props enum for <Balota>. Kept beside the component instead of in
// core/constants/ because nothing outside this component defines them.

export const BALOTA_SIZES = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};

export const BALOTA_STATES = {
    IDLE:     'idle',
    SPINNING: 'spinning',
    LOCKED:   'locked',
};
